import Link from 'next/link';
import MatchSwitch from '@components/common/matchSwitch';
import { useGetMatchPage } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './recommendation.module.scss';

const cx = classnames.bind(styles);

const Recommendation = () => {
  const matchUrl = useGetMatchPage();

  return (
    <div className={cx('infoArea')}>
      <div className={cx('descWrap')}>
        <span className={cx('desc')}>필수정보 입력하고 기업에게 제안을 받아보세요.</span>
        <Link href={matchUrl} legacyBehavior>
          <a className={cx('link', 'pc_profile_match_link_0831')} role="button">
            상세보기
          </a>
        </Link>
      </div>

      <MatchSwitch />
    </div>
  );
};

export default Recommendation;
